import userManager from "@/assets/plugins/mps-common/user/user-manager";
import UserMixin from "@/assets/plugins/mps-common/user/UserMixin";

export default {
    install(Vue) {
        // 전역 변수로 접근토큰관리자 할당.
        Vue.prototype.$userManager = userManager;
        Vue.mixin(UserMixin);
    }
}